import { render, staticRenderFns } from "./ReportBuilder.vue?vue&type=template&id=674535c6&scoped=true"
import script from "./ReportBuilder.vue?vue&type=script&lang=js"
export * from "./ReportBuilder.vue?vue&type=script&lang=js"
import style0 from "./ReportBuilder.vue?vue&type=style&index=0&id=674535c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674535c6",
  null
  
)

export default component.exports